import { styled } from "@mui/material/styles";
import MuiListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import type { ListItemTextProps } from "@mui/material/ListItemText";

type ListItemProps = ListItemTextProps & {
  avatar?: React.ReactNode;
  icon?: React.ReactNode;
};

const StyledListItem = styled(MuiListItem)(({ theme }) => ({
  padding: theme.spacing(1, 1, 1, 0),
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing(5),
}));

export default function ListItem({ avatar, icon, ...props }: ListItemProps) {
  return (
    <StyledListItem>
      {!!avatar && <ListItemAvatar>{avatar}</ListItemAvatar>}
      {!!icon && <StyledListItemIcon>{icon}</StyledListItemIcon>}
      <ListItemText {...props} />
    </StyledListItem>
  );
}
